<template>
  <div class="right">
    <div class="title-body">
      <div class="title-body-title">
        重大事项变更
        <div
          style="
            flex: 1;
            height: 4px;
            margin-top: 18px;
            margin-left: 10px;
            background-image: url(./static/img/bar.png);
          "
        ></div>
      </div>
    </div>
    <div class="infomation">
      <!--内容开始-->
      <div>
        <!--<div
          style="
            width: calc(100% - 40px);
            padding: 25px 20px;
            background-color: rgb(248, 248, 248);
            margin-bottom: 20px;
            font-size: 14px;
            line-height: 25px;
          "
        >
          温馨提示：
        </div>-->
        <div>
          <div class="tableList">
            <div
              class="
                el-table
                el-table--fit
                el-table--border
                el-table--enable-row-hover
                el-table--enable-row-transition
              "
            >
              <div class="hidden-columns">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="el-table__header-wrapper">
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  class="el-table__header"
                  style="width: 994px"
                >
                  <colgroup>
                    <col name="el-table_39_column_152" width="80" />
                    <col name="el-table_39_column_153" width="150" />
                    <col name="el-table_39_column_154" width="457" />
                  </colgroup>
                  <thead class="has-gutter">
                    <tr class="">
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_39_column_152 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">序号</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_39_column_153 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">日期</div>
                      </th>
                      <th
                        colspan="1"
                        rowspan="1"
                        class="el-table_39_column_154 is-center is-leaf"
                        style="
                          background-color: rgb(241, 241, 241);
                          font-size: 16px;
                          font-weight: bold;
                          color: rgb(51, 51, 51);
                        "
                      >
                        <div class="cell">内容</div>
                      </th>
                      <th class="gutter" style="width: 0px; display: none"></th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="el-table__body-wrapper is-scrolling-none">
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  class="el-table__body"
                  style="width: 994px"
                >
                  <colgroup>
                    <col name="el-table_39_column_152" width="80" />
                    <col name="el-table_39_column_153" width="150" />
                    <col name="el-table_39_column_154" width="457" />
                  </colgroup>
                  <tbody>
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">1</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2021年7月1日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span
                              >公司股东由原先上海新炬高新技术服务有限公司、中智资产管理有限公司、伯馥（上海）企业发展有限公司、上海俊佳服饰有限公司，四家股东变更为伯馥（上海）企业发展有限公司、上海俊佳服饰有限公司、中智上海经济技术合作有限公司</span
                            >
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">2</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2021年7月14日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span
                              >中盈北京分公司住所地址由原北京市朝阳区光华路7号11层A17室变更为北京市朝阳区光华路7号21层25东25A3-2</span
                            >
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">3</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2021年8月2日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>上海银保监局核准赵欣女士担任公司董事长</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">4</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2022年2月9日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>根据公司战略发展需要，并经上海市徐汇区市场监督管理局审核批准，上海中盈保险经纪有限公司自2022年2月9日起更名为“中智保险经纪（上海）有限公司”。现将有关事宜公告如下：

     1.自本公告发布之日起，公司所有对内及对外文件、资料、发票开具、账号、税号等全部使用新公司名称。

     2.公司更名后，业务主体和法律关系不变，原签订的合同继续有效，原有的业务关系和服务承诺保持不变。</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">5</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2022年3月10日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>根据公司战略发展需要，经过苏州市市场监督管理局审核批准，上海中盈保险经纪有限公司江苏分公司自2022年3月10日更名为中智保险经纪（上海）有限公司江苏分公司</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">6</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2022年3月9日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>根据公司战略发展需要，经过北京市朝阳区市场监督管理局审核批准，上海中盈保险经纪有限公司北京分公司自2022年3月9日更名为中智保险经纪（上海）有限公司北京分公司</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">7</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2022年6月16日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>经上海市市场监督管理局批准，我司股东“中智上海经济技术合作有限公司”的公司名称由原“中智上海经济技术合作有限公司”变更为 “中智经济技术合作股份有限公司”</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">8</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2022年07月15日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>经苏州工业园区市场监督管理局批准， 住所地址由苏州工业园区思安街99号鑫能商务广场1幢1105室变更为苏州工业园区苏惠路88号环球财富广场1幢2501室</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">9</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2023年1月6日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>上海银保监局核准杨君女士担任公司副总经理</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">10</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2023年1月16日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block; text-align: left;">
                            <span>我公司于2023年01月04日成功延续中华人民共和国保险中介许可证有效期，许可证相关公告内容如下：
                            <br />机构名称：中智保险经纪（上海）有限公司
                            <br />业务范围：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；保险监督管理机构批准的其他业务。
                            <br />批准日期：2010年12月28日（有效期至：2025年12月24日）
                            <br />机构住所：上海市徐汇区衡山路922号2601室、2603室、2604室
                            <br />机构编码：260934000000800
                            <br />联系电话：021-54623888</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">11</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2023年2月8日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>经过上海市徐汇区市场监督管理局批准，公司法定代表人由“赵欣”变更为“隋清洁”</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">12</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2024年1月23日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>经过上海市徐汇区市场监督管理局审核批准，自2024年1月23日起中智保险经纪（上海）有限公司住所地址变更为上海市徐汇区沪闵路9299号9楼901室、902室</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">13</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2024年01月31日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block;text-align: left;">
                            <span>我公司于2024年01月31日由于住所地址变更成功换领中华人民共和国保险中介许可证，许可证相关公告内容如下：
                              <br />机构名称：中智保险经纪（上海）有限公司
                              <br />业务范围：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；保险监督管理机构批准的其他业务。
                              <br />批准日期：2010年12月28日（有效期至：2025年12月24日）
                              <br />机构住所：上海市徐汇区沪闵路9299号9楼901室、902室
                              <br />机构编码：260934000000800
                              <br />联系电话：021-54623888</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">14</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2024年8月8日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block;text-align: left;">
                            <span>2024年8月8日经过苏州高新区行政审批局批准，中智保险经纪（上海）有限公司江苏分公司住所地址由苏州工业园区苏惠路88号环球财富广场1幢2501室变更为苏州高新区狮山街道狮山路22号1幢101室人才广场2503</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">15</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2024年9月4日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block;text-align: left;">
                            <span>2024年9月4日经过北京市朝阳区市场监督管理局批准，中智保险经纪（上海）有限公司北京分公司住所地址由北京市朝阳区光华路7号21层25东25A3-2变更为北京市朝阳区光华路7号24层28B1
</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                    <!---->
                    <tr class="el-table__row">
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_152 is-center"
                      >
                        <div class="cell">16</div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_153 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block">
                            <span>2025年12年24日</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_39_column_154 is-center"
                      >
                        <div class="cell">
                          <div style="display: inline-block;text-align: left;">
                            <span>经国家金融监督管理总局上海监管局批准，中智保险经纪（上海）有限公司续期换证及机构住所自2025年12月24日起变更为上海市沪闵路9299号18层1806室，并已换领中华人民共和国保险中介许可证，相关许可证记载内容如下：
机构名称：中智保险经纪（上海）有限公司
业务范围：在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；保险监督管理机构批准的其他业务。
批准日期：2010年12月28日（有效期至2028年12月24日）
机构住所：上海市沪闵路9299号18层1806室
机构编码：260934000000800
发证机关：国家金融监督管理总局上海监管局
发证日期：2025年12年24日
机构联系电话：021-34014626
</span>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!---->
                  </tbody>
                </table>
                <!----><!---->
              </div>
              <!----><!----><!----><!---->
              <div
                class="el-table__column-resize-proxy"
                style="display: none"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!--内容结束-->
    </div>
  </div>
</template>

<script>
export default {
  name: "QueryAndChecked",
  components: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less">
@import "./../assets/table";
</style>



// WEBPACK FOOTER //
// src/pages/queryAndChecked.vue